import { Player } from '@lottiefiles/react-lottie-player';
import React from "react";
import withRoot from "../withRoot";
import LottieP404Icon from './../animations/P404.json';
import { Button, RmBodyZone } from 'randmarcomps';
import { ExternalLinkIcon } from 'lucide-react';
import RmPageHeader from "../components/layout/RmPageHeader";

const P404: React.FC = () => {
  return (
    <>
      <RmPageHeader
        title="Page Not Found"
        subtitle="The page you requested is unavailable in this portal."
      />

      <RmBodyZone className="space-y-6 pb-10">
        <main className="mt-4 grid place-content-center place-items-center text-center">
          <Player
            autoplay
            loop
            speed={0.5}
            src={LottieP404Icon}
            className="h-[500px] w-[500px] bg-transparent"
          />
          <section className='mt-4 rounded-lg bg-white p-6'>
            <h2>Looks like this is not ready yet!</h2>
            <p>Something awesome is about to arrive, hang tight!</p>
            <a href="https://dashboard.randmar.io" target="_blank" rel="noopener noreferrer">
              <Button className='mt-4'>
                <ExternalLinkIcon className='mr-2' />
                Return to Dashboard
              </Button>
            </a>
          </section>
        </main>
      </RmBodyZone>
    </>
  );
};

export default withRoot(P404);
